var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    viewBox: "0 0 150 150",
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.414 1.625H135v147H17.414zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f9a92c",
    d: "m89.852 142.797-9.88 4.492a9.1 9.1 0 0 1-7.538 0l-9.88-4.492c-27.476-12.504-45.113-39.906-45.113-70.094V18.324a5.846 5.846 0 0 1 4.668-5.726L74.453 1.87a8.658 8.658 0 0 1 3.5 0l52.34 10.727a5.846 5.846 0 0 1 4.672 5.726v54.38c0 30.187-17.637 57.589-45.113 70.093zm0 0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1f4482",
    d: "M61.758 100.46 39.996 78.696a5.854 5.854 0 0 1 0-8.277l5.832-5.832a5.852 5.852 0 0 1 8.281 0L65.9 76.375l32.398-32.402a5.859 5.859 0 0 1 8.281 0l5.832 5.836a5.854 5.854 0 0 1 0 8.277L70.04 100.46a5.859 5.859 0 0 1-8.282 0zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.8faf795dce842e78c794e9bacd950469.svg";
export { ForwardRef as ReactComponent };